import { SWRConfig } from 'swr';
import serverStore from '../lib/utils/serverStore';
import {
  settingService,
} from '../lib/services';
import { axiosInstance } from '../lib/utils';
import { setGraphContext } from '../apollo-client';
import { Title } from '../lib/components'
import Head from 'next/head';

export default function MentionsLegales({ fallback, domain }) {
  //TODO: remplacer URL dans le contenu

  return (
    <div className="py-2 text-lg">
      <SWRConfig value={{ fallback }}>
        <Head>
          <title>Animation & Éducation - Mentions légales</title>
          <meta name="description" content="Mentions Légales du site de vente de l'OCCE pour la revue Animation & Éducation."></meta>
        </Head>
        <section className="mx-5 lg:mx-20 xl:mx-40">
          <Title>Mentions Légales</Title>
          <p className="mb-10">
            Site de vente de l'OCCE
            <br />
            Association reconnue d'utilité publique
            <br />
            101 bis, rue du Ranelagh
            <br />
            75016 PARIS
          </p>
          <ul>
            <li>
              <h2 className="text-3xl text-blue-dark flex mt-10 mb-3 italic ">
                <span className="hidden xs:inline w-40 h-1 bg-blue-dark
                self-center mr-10"></span>
                RESPONSABLE DE LA PUBLICATION
              </h2>
              <p>
                Alain BARRAULT en sa qualité de Président de la fédération OCCE.
              </p>
            </li>
            <li className="mt-5">
              <h2 className="text-3xl text-blue-dark flex mt-10 mb-3 italic ">
                <span className="hidden xs:inline w-40 h-1 bg-blue-dark
                self-center mr-10"></span>
                HEBERGEMENT
              </h2>
              <p>
                SOTIAF TELEMATIQUE ASSOCIES
                <br />
                12 rue Jacqueline Auriol
                <br />
                35136 ST Jacques de la Lande
                <br />
                Tel 02 99 551 551
                <br />
                SAS au capital de 237 000€
              </p>
            </li>
            <li className="mt-5">
              <h2 className="text-3xl text-blue-dark flex mt-10 mb-3 italic ">
                <span className="hidden xs:inline w-40 h-1 bg-blue-dark
                self-center mr-10"></span>
                GESTION DES DONNEES PERSONNELLES
              </h2>
              <p>
                L’Utilisateur est informé des réglementations concernant la communication marketing,
                la loi du 21 Juin 2014 pour la confiance dans l’Économie Numérique, la Loi Informatique
                et Liberté du 06 Août 2004 ainsi que du Règlement Général sur la Protection des Données (RGPD : n° 2016-679).
              </p>
            </li>
            <li className="mt-5">
              <h2 className="text-3xl text-blue-dark flex mt-10 mb-3 italic ">
                <span className="hidden xs:inline w-40 h-1 bg-blue-dark
                self-center mr-10"></span>
                RESPONSABLE DE LA COLLECTE DES DONNEES PERSONNELLES
              </h2>
              <div>
                <p>
                  Les informations communiquées par chaque visiteur sont sous sa seule responsabilité :
                  elles doivent être exactes et licites. Dès lors qu'elles nous sont communiquées,
                  elles ne sont plus confidentielles mais sont réservées au seul usage interne de l’OCCE pour
                  la gestion des abonnements et de la vente d’Animation & Éducation.
                  <br />
                  La responsabilité de la collecte des données personnelles est confiée à la société SOTIAF,
                  prestataire de l’OCCE pour la gestion des abonnements et de ce site. La société SOTIAF,
                  liée par un accord cadre à l’OCCE, en qualité d’utilisateur des fichiers transmis par le
                  Client pour les besoins de la réalisation de la prestation, déclare connaître, respecter et
                  assumer ses obligations au regard de la Loi Informatique et Libertés. N° 78-17 du 6 janvier 1978,
                  de la Loi pour une République Numérique du 16 octobre 2016 et du Règlement Général sur la Protection
                  des Données. Le Prestataire en supporte les obligations et contraintes qui lui incombent. Le rôle du
                  Prestataire se limite à mettre en œuvre les moyens adaptés en vue d’assurer l’intégrité et la sécurité
                  de ces données. L’OCCE en sa qualité de responsable de traitement déclare avoir procédé à toutes les
                  formalités nécessaires à la mise en œuvre des traitements qu’il exploite.
                  <br />
                  À ce titre, le Prestataire réalise pour le compte de l’OCCE des prestations nécessitant l’utilisation
                  et/ou le stockage de données personnelles relatives à des personnes physiques, et dans le cadre de la
                  règlementation CNIL et du règlement (UE) 2016/679, le Prestataire s’engage à :
                </p>
                <ul className="ml-10">
                  <li>
                    -	Traiter les données personnelles seulement sur instructions documentées (compte-rendu, mails, lettres...)
                    de l’OCCE responsable du traitement,
                  </li>
                  <li>
                    -	Effectuer les traitements qui lui sont demandés par l’OCCE sur le territoire français,
                  </li>
                  <li>
                    -	Mettre en place à l’égard de ses salariés traitant les données personnelles un engagement de confidentialité,
                  </li>
                  <li>
                    -	Assurer la sécurité du traitement par des moyens appropriés,
                  </li>
                  <li>
                    -	Mettre en place et tenir régulièrement à jour un registre des traitements effectués pour le compte de l’OCCE,
                  </li>
                  <li>
                    -	Ne pas recourir à la sous-traitance pour effectuer les traitements demandés par l’OCCE. A cet égard,
                    seule une réponse écrite et préalable de l’OCCE, par lequel il accepte une telle sous-traitance de second
                    rang, permettra au sous-traitant d’y recourir. Un contrat reprenant l’intégralité des clauses du présent
                    document devra alors être signé entre le Prestataire et son propre sous-traitant.
                  </li>
                  <li>
                    -	Aider l’OCCE par des mesures techniques et organisationnelles, à exécuter ses obligations à l’égard
                    des personnes dont les données font l’objet de traitements,
                  </li>
                  <li>
                    -	Aider l’OCCE à garantir le respect des obligations concernant la sécurité des données personnelles.
                  </li>
                  <li>
                    -	Notifier à l’OCCE toute faille de sécurité, dans les meilleurs délais après en avoir pris connaissance.
                    Le Prestataire décrira la nature de la faille de sécurité, et si possible le nombre approximatif de personnes
                    concernées et les catégories et le nombre approximatif d’enregistrements de données personnelles concernées,
                  </li>
                  <li>
                    -	Supprimer toutes les données personnelles ou les renvoyer au Client au terme de la prestation, et ce,
                    selon les instructions qui lui seront données par l’OCCE.
                  </li>
                  <li>
                    -	Mettre à la disposition de l’OCCE toutes les informations documentant le respect de ces obligations.
                    Le Prestataire permet la réalisation d’audits et d’inspections, et contribue à ces audits et inspections.
                  </li>
                </ul>
              </div>
            </li>
            <li className="mt-5">
              <h2 className="text-3xl text-blue-dark flex mt-10 mb-3 italic ">
                <span className="hidden xs:inline w-40 h-1 bg-blue-dark
                self-center mr-10"></span>
                FINALITE DES DONNEES COLLECTEES
              </h2>
              <p>
                Aucune de ces informations personnelles collectées ne sera communiquée à des tiers, que ce soit par publication,
                échange, transfert, cession ou vente. La société SOTIAF, agissant sous l'autorité de l’OCCE, qui a accès à ces
                données à caractère personnel, ne peut pas traiter ces données que sur instruction de l’OCCE et pour la vente de
                et l’abonnement à la revue Animation & Education.
                <br />
                Les informations personnelles, aussi précises soient elles, contenues dans le formulaire d’abonnement ou d’achat,
                ont pour seul objectif de permettre à la société SOTIAF agissant sous l’autorité de l’OCCE de traiter et répondre
                à une demande d’abonnement ou d’achat dans les meilleures conditions d'exercice. Elles sont conservées au maximum
                pour une durée de trois ans, même si aucune relation commerciale n'a été établie. En cas d'une relation commerciale
                contractualisée ou de commande, elles sont conservées pendant toute la période contractuelle à laquelle s'ajoute la
                durée de prescription légale et le respect des règles en matière de comptabilité applicables de dix ans.
              </p>
            </li>
            <li className="mt-5">
              <h2 className="text-3xl text-blue-dark flex mt-10 mb-3 italic ">
                <span className="hidden xs:inline w-40 h-1 bg-blue-dark
                self-center mr-10"></span>
                DROIT D’ACCES, DE RECTIFICATION ET D’OPPOSITION
              </h2>
              <p>
                Conformément aux dispositions des articles 38 et suivants de la loi du 6 janvier 1978 « Informatique et Libertés » et
                du Règlement Général sur la Protection des Données, l'internaute peut à tout moment, exercer son droit d'accès, de
                modification, de rectification, de limitation et de suppression des données le concernant.
                <br />
                Toute demande doit être accompagnée d'une copie du titre d'identité avec signature du titulaire de la pièce et
                préciser l'adresse à laquelle la réponse doit être envoyée.
              </p>
              <div>
                <p className="mt-5">
                  Pour exercer ce droit, l'internaute contacte notre Délégué à la Protection des Données soit :
                </p>
                <ul className="list-disc ml-10">
                  <li>A l'adresse postale de l’OCCE, à l'attention du DPO,</li>
                  <li>Soit par mail en écrivant à <a href="mailto:federation@occe.coop" className="underline">federation@occe.coop</a></li>
                </ul>
              </div>
            </li>
            <li className="mt-5">
              <h2 className="text-3xl text-blue-dark flex mt-10 mb-3 italic ">
                <span className="hidden xs:inline w-40 h-1 bg-blue-dark
                self-center mr-10"></span>
                NON-COMMUNICATION DES DONNEES PERSONNELLES
              </h2>
              <p>
                {domain} s’interdit de traiter, héberger ou transférer les Informations collectées sur ses Utilisateurs
                vers un pays situé en dehors de l’Union européenne ou reconnu comme « non adéquat » par la Commission européenne
                sans en informer préalablement l’Utilisateur. Pour autant, {domain} reste libre du choix de ses sous-traitants
                techniques et commerciaux à la condition qu’ils présentent les garanties suffisantes au regard des exigences du
                Règlement Général sur la Protection des Données (RGPD : n° 2016-679).
              </p>
              <p className="mt-5">
                Cependant, si un incident impactant l’intégrité ou la confidentialité des Informations de l’Utilisateur est portée à
                la connaissance de {domain}, celle-ci devra dans les meilleurs délais informer l’Utilisateur et lui communiquer
                les mesures de corrections prises. Par ailleurs {domain} ne collecte aucune « données sensibles ».
              </p>
              <p className="mt-5">
                Aucune information personnelle de l'Utilisateur du site {domain} n'est publiée à l'insu de l'Utilisateur, échangée,
                transférée, cédée ou vendue sur un support quelconque à des tiers.
              </p>
            </li>
            <li className="mt-5">
              <h2 className="text-3xl text-blue-dark flex mt-10 mb-3 italic ">
                <span className="hidden xs:inline w-40 h-1 bg-blue-dark
                self-center mr-10"></span>
                SECURITE DES DONNEES
              </h2>
              <p>
                Quels que soient les efforts fournis, aucune méthode de transmission sur Internet et aucune méthode de stockage électronique
                n'est complètement sûre. Nous ne pouvons en conséquence pas garantir une sécurité absolue. Si nous prenions connaissance d'une
                brèche de la sécurité, nous avertirions les utilisateurs concernés afin qu'ils puissent prendre les mesures appropriées.
                Nos procédures de notification d’incident tiennent compte de nos obligations légales, qu'elles se situent au niveau national ou
                européen. Nous nous engageons à informer pleinement nos utilisateurs de toutes les questions relevant de la sécurité de leur
                compte et à leur fournir toutes les informations nécessaires pour les aider à respecter leurs propres obligations réglementaires
                en matière de reporting.
              </p>
              <p className="mt-5">
                Lors du traitement des Données Personnelles, {domain} prend toutes les mesures raisonnables visant à les protéger contre
                toute perte, utilisation détournée, accès non autorisé, divulgation, altération ou destruction.
              </p>
            </li>
            <li className="mt-5">
              <h2 className="text-3xl text-blue-dark flex mt-10 mb-3 italic ">
                <span className="hidden xs:inline w-40 h-1 bg-blue-dark
                self-center mr-10"></span>
                COOKIES
              </h2>
              <p>
                Lorsqu'ils visitent un site web, les utilisateurs doivent être informés et donner leur consentement préalablement au dépôt
                ou la lecture de cookies ou autres traceurs, à moins que ces traceurs ne bénéficient d’une des exemptions prévues par
                l’article 82 de la loi Informatique et Libertés.
              </p>
              <p className="mt-5">
                Un cookie consiste en un bloc de données qui permet d'enregistrer des informations relatives à la navigation d'un utilisateur
                sur un site internet afin de procéder à des analyses de fréquentation des sites et d'en améliorer la qualité et la pertinence :
                l’OCCE n'utilise pas cette technologie.
                <br />
                A l'occasion d'une visite sur notre site, aucun cookie ne pourra donc s'installer automatiquement sur le logiciel de navigation
                d'un utilisateur.
                <br />
                Le site de vente de l’OCCE est un site « boutique » pour effectuer des ventes en ligne de la revue. Les pages parcourues par un
                internaute fournissent une information consultative. Les différentes parties de notre site sont fonctionnelles sans l'acceptation
                de cookies. Toutefois, les fonctionnalités de Google Analytics sont activées pour ce site.
              </p>
              <p className="mt-5">
                Pour plus d’informations concernant la règlementation en vigueur, nous vous proposons de consulter le site de la CNIL :
                <br />
                <a
                  href="https://www.cnil.fr/fr/cookies-et-traceurs-comment-mettre-mon-site-web-en-conformite"
                  rel="nofollow"
                  target="_blank"
                  className="underline"
                >
                  https://www.cnil.fr/fr/cookies-et-traceurs-comment-mettre-mon-site-web-en-conformite
                </a>
              </p>
            </li>
          </ul>
        </section>
      </SWRConfig>
    </div>
  );
}

export const getServerSideProps = async function getServerSideProps({ req, res }) {
  axiosInstance.setAxiosContext(req, res)
  setGraphContext(req, res)

  let setting = serverStore.get('setting');

  let fallback = {};
  fallback[settingService.SETTING_GET_SETTING_PATH] = setting;
  return {
    props: { fallback: fallback, setting: setting, domain: req.headers.host },
  };
}